import { gql } from "@apollo/client";

export const GET_COMBINED_LANDING_PAGES = gql`
  query GetCombinedLandingPages($site_url: String!, $property_id: String!, $start_date: String, $end_date: String, $limit: Int, $email: String) {
    combinedLandingPages(site_url: $site_url, property_id: $property_id, start_date: $start_date, end_date: $end_date, limit: $limit, email: $email) {
      success
      data
    }
  }
`;

export const GET_COMBINED_KEYWORDS = gql`
  query GetCombinedKeywords($site_url: String!, $property_id: String!, $start_date: String, $end_date: String, $limit: Int, $email: String) {
    combinedKeywords(site_url: $site_url, property_id: $property_id, start_date: $start_date, end_date: $end_date, limit: $limit, email: $email) {
      success
      data
    }
  }
`;

export const GET_COMBINED_OPPORTUNITIES = gql`
  query GetCombinedOpportunities($site_url: String!, $property_id: String!, $start_date: String, $end_date: String, $email: String) {
    combinedOpportunities(site_url: $site_url, property_id: $property_id, start_date: $start_date, end_date: $end_date, email: $email) {
      success
      data
    }
  }
`;

export const GET_COMBINED_FUNNEL = gql`
  query GetCombinedFunnel($site_url: String!, $property_id: String!, $start_date: String, $end_date: String, $email: String) {
    combinedFunnel(site_url: $site_url, property_id: $property_id, start_date: $start_date, end_date: $end_date, email: $email) {
      success
      data
    }
  }
`;

// export const GET_COMBINED_DASHBOARD = gql`
//   query GetCombinedDashboard($site_url: String!, $property_id: String!, $start_date: String, $end_date: String, $email: String) {
//     combinedDashboard(site_url: $site_url, property_id: $property_id, start_date: $start_date, end_date: $end_date, email: $email) {
//       success
//       data
//     }
//   }
// `;

export const GET_COMBINED_DASHBOARD = gql`
  query GetCombinedDashboard($site_url: String!, $property_id: String!, $start_date: String, $end_date: String, $email: String) {
    combinedDashboard(site_url: $site_url, property_id: $property_id, start_date: $start_date, end_date: $end_date, email: $email) {
      success
      data
    }
  }
`;
